import { render, staticRenderFns } from "./XFormFooterButtons.vue?vue&type=template&id=1ac69100&"
import script from "./XFormFooterButtons.vue?vue&type=script&lang=js&"
export * from "./XFormFooterButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports